import {cloneDeep} from 'lodash';
import * as React from 'react';

import {IPostcardImage, IDocument, IUserData} from '../../../../infrastructure/interfaces';
import PostcardImageFrontForm from '../../../DocumentEditor/PostcardImageFrontEditorForm';
import SettingsNav from './SettingsNav';

export interface IPostcardImageFrontProps {
  document: IDocument;
  postcardImages: IPostcardImage[];
  userData: IUserData;
  saveDocument(document: IDocument, userID: string, redirect?: string): void;
  updateModelDocument(document: IDocument): void;
  cancelDocument(): void;
}

export interface IPostcardImageFrontState {
  document: IDocument;
}


export default class PostcardImageFront extends React.Component<IPostcardImageFrontProps, IPostcardImageFrontState> {
  contentNode: Element;
  constructor(props: IPostcardImageFrontProps) {
    super(props);
    this.state = {
      document: cloneDeep(props.document),
    };
  }

  componentWillUnmount() {
    if (this.props.updateModelDocument) {
      this.contentNode.parentElement!.scrollTop = 0;
      this.props.updateModelDocument(this.state.document);
    }
  }

  componentWillReceiveProps(nextProps: IPostcardImageFrontProps) {
    if (nextProps.document !== this.props.document) {
      this.setState({ document: cloneDeep(nextProps.document) });
    }
  }

  onPostcardImageFrontChange = (postcardImageFront: IPostcardImage) => {
    this.setState({
      document: {
        ...this.state.document,
        postcardImageFront,
      },
    });
  }

  cancel = () => {
    this.setState({ document: cloneDeep(this.props.document) });
    if (this.props.cancelDocument) {
      this.props.cancelDocument();
    }
  }

  onSave = () => {
    this.props.saveDocument(this.state.document, this.props.userData.id);
  }

  render() {
    return (
      <div className="cropsEditorContainer" ref={(node) => { this.contentNode = node!; }}>
        <SettingsNav
          cancel={this.cancel}
          document={this.state.document}
          onSave={this.onSave}
        />
        <div className="">
          <div className="cropsContainerTitle">
            Select the back postcard background image:
        </div>
        </div>
        <PostcardImageFrontForm
          document={this.state.document}
          postcardImagesList={this.props.postcardImages}
          onPostcardImageChangeFront={this.onPostcardImageFrontChange}
          className="settingsCropsListContainer"
        />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Editor/components/Settings/PostcardImageFrontEditor.tsx